<template>
  <nav>
    <v-btn
      data-testid="back-button"
      outlined
      elevation="0"
      class="rounded-xxl text-none px-4 mt-10"
      :class="hideSubmit ? '' : 'mr-8'"
      @click="goBack"
    >
      {{ $t(cancelButtonText) }}
    </v-btn>
    <v-btn
      v-if="!hideSubmit"
      data-testid="submit-button"
      type="submit"
      :disabled="loading"
      :color="nextButtonColor"
      class="rounded-xxl text-none white--text px-4 mt-10"
      @click="proceedSubmit"
    >
      {{ $t(nextButtonText) }}<v-icon v-if="nextIcon">mdi-chevron-right</v-icon>
    </v-btn>
  </nav>
</template>

<script>

export default {

    props: {
        nextButtonText: {
          type: String,
          default: ''
        },
        loading: Boolean,
        cancelButtonLink: {
          type: String,
          default: ''
        },
        hideSubmit: {
          type: Boolean,
          default: false
        },
        cancelButtonText:{
          type: String,
          default: 'cancel'
        },
        nextButtonColor: {
          type: String,
          default: 'darktext'
        },
        nextIcon: {
          type: Boolean,
          default: true
        }
    },
    methods:{
        goBack(){
            if(!this.cancelButtonLink){
              this.$router.go(-1) 
            }else{
              this.$router.push({path: this.cancelButtonLink})
            }
            
        },
        proceedSubmit(){
            this.$emit('proceedSubmit')
        }
    }
}
</script>